import React from "react";

import {
    PhotosPricingTableHeaderTitle,
    PhotosPricingTableHeaderPrice,
    PhotosPricingTableHeader,
    CreativeCommonsIcon
} from "./styles";
import Flexbox from "core/Flexbox";

export const PhotosPricingTableHeaderBasic = () => (
    <PhotosPricingTableHeader>
        <PhotosPricingTableHeaderTitle type="h6" size="xs" alignment="center">
            <Flexbox inlineFlex alignItems="center">
                Basic <CreativeCommonsIcon title="Creative Commons license" />
                Photo Downloads
            </Flexbox>
        </PhotosPricingTableHeaderTitle>
        <PhotosPricingTableHeaderPrice>$0</PhotosPricingTableHeaderPrice>
    </PhotosPricingTableHeader>
);

export const PhotosPricingTableHeaderLarge = () => (
    <PhotosPricingTableHeader>
        <PhotosPricingTableHeaderTitle type="h6" size="xs" alignment="center">
            Large Photo Downloads
        </PhotosPricingTableHeaderTitle>
        <PhotosPricingTableHeaderPrice>$8.50</PhotosPricingTableHeaderPrice>
    </PhotosPricingTableHeader>
);

export const PhotosPricingTableHeaderFullRes = () => (
    <PhotosPricingTableHeader>
        <PhotosPricingTableHeaderTitle type="h6" size="xs" alignment="center">
            Full-Res Photo Downloads
        </PhotosPricingTableHeaderTitle>
        <PhotosPricingTableHeaderPrice>$33</PhotosPricingTableHeaderPrice>
    </PhotosPricingTableHeader>
);
